/* eslint-disable */
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['appTypeSelect', 'childSelectContainer', 'childSelect', 'submit']

  appTypeSelectTargetConnected() {
    // Triggers a change event on the appTypeSelect so the child inputs are populated when rendering the form after
    // a validation error
    if (this.appTypeSelectTarget.value !== '') {
      const event = new Event('change');
      this.appTypeSelectTarget.dispatchEvent(event)
    }
  }

  populateChildSelect(event) {
    this.resetChildSelects();
    const params = new URLSearchParams();
    params.append('refresh[app_type]', this.appTypeSelectTarget.value);
  
    const url = `${event.params.url}?${params.toString()}`;
  
    fetch(url)
    .then(response => response.text())
    .then(data => {
      this.childSelectContainerTarget.innerHTML = data;
      this.enableSubmit();
    });
  }

  resetChildSelects() {
    this.childSelectTargets.forEach(select => {
      select.disabled = true;
      select.innerHTML = '';
      const option = document.createElement('option');
      option.textContent = 'Please wait ...';
      select.appendChild(option);
    });
  }

  enableSubmit() {
    this.submitTarget.disabled = false;
  }
}
